'use strict';

angular.module('upHelpers').constant('UdoLink', {
	ACCOUNT: 4,
	CONTACT: 6,
	CAMPAIGN: 1
});
